import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Reveal } from "./Reveal";

const IMG = "/story/black-dog-society-night-walk-alone.webp";

export const Mission = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const scale = useTransform(scrollYProgress, [0, 1], [1.25, 1]);

  return (
    <section id="mission" ref={ref} data-testid="mission" className="relative py-28 md:py-44 border-t border-bds-border">
      <div className="mx-auto max-w-[1600px] px-6 md:px-12 grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-16 items-center">
        <div className="md:col-span-6 order-2 md:order-1">
          <Reveal>
            <span className="font-mono-bds text-xs uppercase tracking-[0.3em] text-bds-accent">
              Why we exist
            </span>
          </Reveal>
          <Reveal delay={0.05}>
            <h2 className="font-serif-display font-light text-4xl md:text-6xl lg:text-7xl tracking-tight leading-[0.95] mt-6 mb-8">
              The darkness is <span className="italic text-bds-muted">shared</span>, so it weighs less.
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="font-grotesk text-base md:text-lg text-bds-muted leading-relaxed max-w-xl mb-6">
              Black Dog Society exists for the days that don&apos;t make it to social media. We turn the sketches from our worst nights into wearable art — a quiet signal to others that they aren&apos;t the only one carrying something heavy.
            </p>
          </Reveal>
          <Reveal delay={0.15}>
            <div className="grid grid-cols-2 gap-6 mt-12 max-w-md">
              {[
                { k: "10%", v: "of every drop funds mental-health support" },
                { k: "100%", v: "original art, drawn by hand, never AI" },
              ].map((s) => (
                <div key={s.k} className="border-l border-bds-border pl-5">
                  <div className="font-serif-display text-4xl md:text-5xl">{s.k}</div>
                  <p className="font-mono-bds text-[11px] uppercase tracking-[0.15em] text-bds-muted mt-2 leading-relaxed">
                    {s.v}
                  </p>
                </div>
              ))}
            </div>
          </Reveal>
        </div>

        <div className="md:col-span-6 order-1 md:order-2">
          <div className="relative overflow-hidden aspect-[4/5]">
            <motion.img
              style={{ scale }}
              src={IMG}
              alt="A solitary figure walking a dark street at night, Wellington New Zealand"
              loading="lazy"
              className="absolute inset-0 w-full h-full object-cover grayscale contrast-125"
            />
            <div className="absolute inset-0 bg-bds-bg/30 mix-blend-multiply" />
            <div className="absolute bottom-0 left-0 right-0 p-6 md:p-8 bg-gradient-to-t from-bds-bg to-transparent">
              <p className="font-serif-display italic text-2xl md:text-3xl">&ldquo;You wear the piece. It starts the conversation.&rdquo;</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
